import { computed } from "vue";
import useAPIRequest from "@/composables/useAPIRequest";
import { PageDTO, PageModel } from "@/entities/Page";
import { ref } from "vue";

const fetchPageQuery = `
*[_type == 'page' && page == $page && !(_id in path('drafts.**'))][0]{
  _id,
  title,
  page,
  body,
  links,
}`;

const _pages = ref<Record<PageModel["page"], PageModel>>({});
const currentPage = ref<string | undefined>();

interface FetchPageParams {
  page: string;
}
const { fetch, requestState } = useAPIRequest<PageDTO, FetchPageParams>();

export default function usePage() {
  const fetchPage = async (params: FetchPageParams) => {
    currentPage.value = params.page;
    if (_pages.value[params.page]) return;
    await fetch(fetchPageQuery, params);
    if (!requestState.value.data) return;
    _pages.value[params.page] = new PageModel(requestState.value.data);
  };

  const page = computed(() =>
    currentPage.value ? _pages.value[currentPage.value] : null
  );

  return {
    page,
    fetchPage,
    requestState,
  };
}
